import { render, staticRenderFns } from "./TalentLogo.vue?vue&type=template&id=6192cb8a&"
import script from "./TalentLogo.vue?vue&type=script&lang=ts&"
export * from "./TalentLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports